<template>
    <div style="padding: 0 20px; display: flex; flex-direction: column; background-color: white;">
        <div style="margin: 34px 0; font-weight: bold;">重置密码</div>
        <van-field v-model="userPhone" :border="false" placeholder="请输入手机号" type="tel"
                   style="background-color: #FAFAFA; margin-bottom: 30px;"/>
        <van-field v-model="validCode" :border="false" placeholder="请输入验证码" type="number"
                   style="background-color: #FAFAFA; margin-bottom: 30px;">
            <div slot="button">
                <div v-show="!start" style="color: #066BEE;" @click="startCountDown">发送验证码</div>
                <van-count-down v-show="start" ref="countDown" :time="time" format="ss秒后重新获取" @finish="finished"/>
            </div>
        </van-field>
        <van-field v-model="loginPwd" :border="false" placeholder="请输入新密码" type="password"
                   style="background-color: #FAFAFA; margin-bottom: 30px;"/>
        <van-field v-model="confirmPassword" :border="false" placeholder="请输入确认密码" type="password"
                   style="background-color: #FAFAFA; margin-bottom: 15px;"/>
        <div style="font-size: 14px; margin-bottom: 40px; color: #666666;">已有账号，<span style="color: #066BEE;"
                                                                                      @click="gotoLogin">前去登录</span>
        </div>
        <van-button type="info" @click="register" style="margin-bottom: 50px;">重置</van-button>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {CountDown, Field, Notify} from 'vant';

    Vue.use(CountDown).use(Field).use(Notify);
    export default {

        name: "ForgotPassword",
        data() {
            return {
                start: false,
                time: 60 * 1000,
                code: '',
                phone: '',
                password: '',
                confirmPassword: ''
            }
        },
        methods: {
            gotoLogin() {
                this.$router.back();
            },
            startCountDown() {
                this.$axios.get("/user/verifyCode", {params: {phoneNum: this.userPhone, type: 'forgetPwd'}}).then(res => {
                    if (res.code == 200) {
                        this.start = true;
                        this.$refs.countDown.start();
                    }
                })
            },
            finished() {
                this.$refs.countDown.reset();
                this.start = false;
            },
            register() {
                if (this.userPhone.length === 0) {
                    Notify({
                        message: '请输入手机号',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.validCode.length === 0) {
                    Notify({
                        message: '请输入验证码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.loginPwd.length === 0) {
                    Notify({
                        message: '请输入新密码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.loginPwd.length < 6) {
                    Notify({
                        message: '密码长度不能少于6位',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                if (this.loginPwd != this.confirmPassword) {
                    Notify({
                        message: '两次密码输入不一致',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return;
                }
                let params = {userPhone: this.userPhone, loginPwd: this.loginPwd, validCode: this.validCode}
                this.$axios.post("/user/forget", params).then(res => {
                    if (res.data === 1) {
                        this.$router.back();
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
